module.exports = "https://coursera_assets.s3.amazonaws.com/images/0ed1135eb41b9c56775bfd4e3b2835a6.png";